import React from 'react';
import { Grid, TextareaAutosize, Typography } from '@material-ui/core';
import { btLightBlueColor } from '../../../assets/jss/nextjs-material-kit-pro';

const questions = [
  {
    label: 'Can you share a moment when the applicant demonstrated integrity, empathy, or leadership in a meaningful way?',
    name: 'integrityEmpathyLeadership',
  },
  {
    label: 'Has the applicant faced a significant challenge, and how did they respond or grow from that experience?',
    name: 'significantChallenge',
  },
  {
    label:
      'What aspects of the applicant’s character or experience make them a strong fit for the Successful Futures program (Housing or Community Supports) and/or strengthen their scholarship application?',
    name: 'characterFit',
  },
  {
    label:
      'Can you share a specific story or moment that highlights the applicant’s strengths or the positive impact they’ve made, based on your personal experience with them?',
    name: 'strengthsStory',
  },
  {
    label: 'Is there any additional insight or information you’d like to provide about this applicant that hasn’t been covered yet?',
    name: 'additionalInsight',
  },
];

const InsightfulRecommendation = ({ className, values = {}, onChange, classes = {} }) => (
  <Grid container direction="column" className={className} style={{ textAlign: 'left', width: '76%', margin: '0 auto' }} spacing={2}>
    <Grid item xs={12}>
      <Typography variant="h6" style={{ color: btLightBlueColor, fontWeight: 600 }}>
        Insightful Recommendation
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="body1" paragraph>
        Please answer the following questions with brief but specific examples. Your insights will help us better understand the applicant’s
        character, resilience, and alignment with the Successful Futures program. We encourage responses that are focused, honest, and grounded in
        your direct experience with the applicant.
      </Typography>
    </Grid>
    {questions.map((q) => (
      <React.Fragment key={q.name}>
        <Grid item xs={12}>
          <Typography variant="body1" paragraph>
            {q.label}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 16 }}>
          <TextareaAutosize
            minRows={4}
            maxRows={8}
            name={q.name}
            value={values[q.name] || ''}
            onChange={onChange}
            placeholder="Enter your response here..."
            className={classes.textAreaFont}
            style={{ width: '100%', borderRadius: 4, borderColor: '#ccc' }}
          />
        </Grid>
      </React.Fragment>
    ))}
  </Grid>
);

export default InsightfulRecommendation;
